import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { TemplatesService, EmailTemplateDto, LocalizationsEmailTemplate } from 'app/services/template/TemplatesService';
import { AdminService } from 'app/services/admin/AdminService';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';
import { FormControl, Validators } from '@angular/forms';
import { AssessmentTypeEnum } from 'app/core/enums/assessment-type-enum';
import { TemplatePurposeEnum } from 'app/core/enums/template-purpose-enum';
import { UserTypeEnum } from 'app/core/enums/user-type-enum';

@Component({
  selector: 'app-new-coach-email-template',
  templateUrl: './new-coach-email-template.component.html',
  styleUrls: ['./new-coach-email-template.component.scss']
})
export class NewCoachEmailTemplateComponent implements OnInit {
    name: string;
    purpose: string;
    type: string;
    niche: string;
    fieldsOpen: boolean = true;
    fieldsModified: boolean = false;
    purposes: any[] = [];
    niches: any[] = [];
    languages: any[] = [];

    public editor;
    public editorContent = ``;
    public editorOptions = { placeholder: 'insert content...' };

    templateFields: any[] = [];
    htmlBody: string = null;
    localizations: LocalizationsEmailTemplate[] = [];
    templateId: number = 0;

    selectedType = 'Regular';
    userTypes: any[] = [];
    userType: number;
    isStandard: boolean = false;
    showDelete: boolean = false;
    standardtemplate: boolean = false;
    assessmentsTypes: any[] = [];
    public sendingPreview = false;
    public savingTemplate = false;

    recipientInputControl = new FormControl('', [Validators.email, Validators.required]);
    constructor(
        private _AdminService: AdminService,
        private _TemplatesService: TemplatesService,
        private activatedRoute: ActivatedRoute,
        private _Globals: Globals,
        private toastr: ToastrService,
        private _router: Router,
        private _AssessmentsService: AssessmentsService
    ) {
        this.activatedRoute.params.subscribe(params => {
            console.log('PARAMS', params);

            if (params['isStandard'] == 'false') {
                this.isStandard = false;
                this.showDelete = false;
            }
            if (params['isStandard'] == 'true') {
                this.isStandard = true; 
                this.showDelete = true;
            }
            console.log('isStandard', this.isStandard);

            let isEmpty = jQuery.isEmptyObject(params);
            if (isEmpty) {
                this.templateId = 0;
            } else {
                this.templateId = parseInt(params['id']);
            }

            if (this.isStandard) this.standardtemplate = true;


            //console.log('name',this.name);
        });
    }

    ngOnInit() {
        //setTimeout(() => {
        //    var container = this.editor.addContainer('ql-custom');
        //}, 2800);

        this.getTemplateFields();
        this.getTemplatePurposes();
        this.getNiches();
        this.getAssessmentTypes();
        this.getLanguages();
        if (this.templateId != 0) {
            this.getEmailTemplate();
        }
        //this.getUserTypes();   
        this.getUserTypesByTemplateType();
    }

    getSelectedOptionText(event: Event) {
        let selectElementText = event.target['options']
        [event.target['options'].selectedIndex].text;
        console.log(selectElementText);
        this.selectedType = selectElementText;
    }

    getAssessmentTypes() {
        this._AssessmentsService.getAssessmentTypes().subscribe((data: any) => {
            console.log('getAssessmentTypes', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.assessmentsTypes = _data;
                console.log(_data);
                //this.loading = false;
            }
        })
    }

    customize() {
        this.isStandard = !this.isStandard;
        this.editor.enable(true);
    }


    getEmailTemplate() {
        this._TemplatesService.getEmailTemplate(this.templateId).subscribe((data: any) => {
            //console.log('response_GetEmailTemplate', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetEmailTemplate', _data);

                this.name = _data.Name;
                this.purpose = _data.Purpose;
                this.userType = _data.UserType;
                this.type = _data.AssessmentType;
                this.niche = _data.Niche;
                this.localizations = _data.Localizations;
                this.htmlBody = this.localizations[0].Body;
                this.checkData(this.localizations[0].Language, this.localizations[0].Subject);
            }
        });
    }

    getTemplateFields() {
        this._AdminService.getTemplateFields().subscribe(data => {
            console.log('response_GetTemplateFields', data.result);
            this.templateFields = data.result;
        });
    }

    //getUserTypes() {
    //    this._GetUserTypes.getUserTypes().subscribe((data: any) => {
    //        console.log('response_GetUserTypes', data.result);

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            let _data = JSON.parse(data.result.Data);
    //            this.userTypes = _data;
    //        }
    //    });
    //}

    getUserTypesByTemplateType() {
        this._AdminService.getUserTypesByTemplateType(2).subscribe((data: any) => {
            console.log('response_GetUserTypes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.userTypes = _data;
            }
        });
        
    }

    getTemplatePurposes() {
        this._AdminService.getTemplatePurposes().subscribe((data: any) => {
            console.log('response_GetTemplatePurposes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                this.purposes = JSON.parse(data.result.Data);
            }
        });
    }

    getNiches() {
        this._AdminService.getNiches().subscribe((data: any) => {
            console.log('respons_GetNiches', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.niches = _data;
            }
        });
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('response__GetLanguages', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.languages = _data;
            }
        })
    }

    insertCustomText() {
        var length = this.editor.getLength();
        this.editor.insertText(length - 1, '<h1>Hello</h1>', 'bold', true);
    }

    insertCustomImages() {
        var range = this.editor.getSelection();
        if (range) {
            if (range.length == 0) {
                console.log('User cursor is at index', range.index);
            } else {
                var text = this.editor.getText(range.index, range.length);
                console.log('User has highlighted: ', text);
            }
            this.editor.insertEmbed(range.index, 'image', 'https://quilljs.com/images/cloud.png');
        } else {
            console.log('User cursor is not in editor');
        }

        var length = this.editor.getLength();
    }

    insertCustomFields(fieldName: string) {
        if (!this.isStandard) {
            var range = this.editor.getSelection();
            if (range) {
                if (range.length == 0) {
                    console.log('User cursor is at index', range.index);
                } else {
                    var text = this.editor.getText(range.index, range.length);
                    console.log('User has highlighted: ', text);
                }
                this.editor.insertText(range.index, `{${fieldName}}`, 'bold', true);

            } else {
                console.log('User cursor is not in editor');

                var length = this.editor.getLength();

                this.editor.insertText(length - 1, `{${fieldName}}`, 'bold', true);
            }
        }
    }

    onEditorBlured(quill) {
        console.log('editor blur!', quill);
    }

    onEditorFocused(quill) {
        console.log('editor focus!', quill);
    }

    onEditorCreated(quill) {
        this.editor = quill;
        console.log('quill is ready! this is current quill instance object', quill);
        if (this.isStandard) {
            this.editor.enable(false);
        }
    }

    onContentChanged({ quill, html, text }) {
        //console.log('quill content is changed!', quill, html, text);
        this.htmlBody = html;
        console.log('html body', this.htmlBody);
    }

    public options: Object = {
        charCounterCount: true,
        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'my_dropdown']
    };

    changeTitle(status) {

        this.fieldsOpen = !status;
        console.log("status", this.fieldsOpen);
        if (this.fieldsOpen) {
            $('.fieldsTitle a').text('Details');
        } else {
            $('.fieldsTitle a').text('Details - [' + $("#aType option:selected").text() + ' | ' + $("#aNiche option:selected").text() + ' | ' + $("#aPurpose option:selected").text() + ']');
        }
    }


    //load localization
    checkData(languageShortCode: string, subject: string) {

        $('#subject').val('');
        this.editorContent = '';

        //this.clearTextArea();
        console.log('check data', this.localizations);

        //check array for display data in text area if exist
        let exist = false;
        let pos = 0;
        for (var i = 0; i < this.localizations.length; i++) {
            if (languageShortCode == this.localizations[i].Language) {
                exist = true;
                pos = i;
            }
        }
        if (exist) {
            //load html content editor
            //load subject
            $('#subject').val(this.localizations[pos].Subject);
            this.editorContent = this.localizations[pos].Body;
            console.log('LOCALIZATION VALUES:', this.localizations[pos].Subject, this.localizations[pos].Body);
        }

        $(".panel-body").focus();

    }

    addLocalization(shortCode: string, subject: string): boolean {
        //if (text != '') {
        console.log('addLocalization');
        if (subject == null || subject.trim() === "") {
            this.toastr.warning('Subject field empty', 'ELI');
            return false;
        }

        if (this.isBodyEmpty(this.htmlBody)) {
            this.toastr.warning('Email body empty', 'ELI');
            return false;
        }

        if (this.localizations.length == 0) {
            let newLocalization = new LocalizationsEmailTemplate();
            newLocalization.Language = shortCode;
            newLocalization.Subject = subject;
            newLocalization.Body = this.htmlBody;

            this.localizations.push(newLocalization);
        }
        else {

            let addNew = true;
            for (var i = 0; i < this.localizations.length; i++) {
                if (this.localizations[i].Language == shortCode) {
                    //property exist
                    addNew = false;
                    this.localizations[i].Body = this.htmlBody;
                    this.localizations[i].Subject = subject;
                }
            }
            if (addNew) {
                //property not exist
                let newLocalization = new LocalizationsEmailTemplate();
                newLocalization.Language = shortCode;
                newLocalization.Subject = subject;
                newLocalization.Body = this.htmlBody;

                this.localizations.push(newLocalization);
            }
        }
        console.log(this.localizations);
        return true;
        //}
    }

    saveTemplate(name: string, type: string, purpose: string, niche: string, userType: string) {
        if (this.savingTemplate) {
            return; 
        }

        if (name == "") {
            this.toastr.warning('Name field empty', "ELI");
            return;
        }


        //adding localization if user not change the select
        let shortCode = $('#languages').val();
        let subject = $('#subject').val();
        if (!this.addLocalization(shortCode, subject)) {
            return;
        }

        let enLocalization = false;

        if (this.localizations.length == 0) {
            this.toastr.warning('No localizations set', "ELI");
            return;
        } else {
            for (var i = 0; i < this.localizations.length; i++) {
                if (this.localizations[i].Language == "en") {
                    enLocalization = true
                }
            }
        }

        if (!enLocalization) {
            this.toastr.warning('English localization missing', 'ELI');
            return;
        }

        if (this.requiredFieldsApply(type, purpose, userType)) {
            const missingFields = this.getMissingRequiredFields();

            if (missingFields.length > 0) {
                this.toastr.warning(`The following required fields are missing in the email body: \n${missingFields.join('\n')}`, 'ELI');
                return;
            }
        }

        // THE STANDARD TEMPLATE IS BEEN CUSTOMIZED (NEW CUSTOM TEMPLATE)
        if (this.standardtemplate) {
            this.templateId = 0;
        } 

        this.savingTemplate = true;
        this._TemplatesService.existsEmailTemplateName(name, this.templateId)
            .subscribe((response) => {
                if (!this._Globals.validationToken(response.result.Result)) {
                    this.toastr.error('We are sorry. An error happened while trying get check the email template name.', 'ELI');
                    this.savingTemplate = false;

                    return;
                } 

                const existsTemplateWithSameName = JSON.parse(response.result.Data) as boolean;

                if (existsTemplateWithSameName) {
                    this.toastr.warning('A template email with this name already exists, change the template name please.', "ELI");
                    this.savingTemplate = false;
                    $('#emailTemplateName').focus();
                    $('#emailTemplateName').select();

                    return;
                }

                let emailTemplate = new EmailTemplateDto();        
                emailTemplate.TemplateId = this.templateId;
                emailTemplate.Name = name;
                emailTemplate.AssessmentType = parseInt(type);
                emailTemplate.Purpose = parseInt(purpose);
                emailTemplate.UserType = parseInt(userType);
                emailTemplate.Niche = parseInt(niche);
                emailTemplate.Owner = this._Globals.getUserId();
                emailTemplate.Localizations = this.localizations;
                emailTemplate.IsGlobal = false;

                console.log('EMAIL TEMPLATE', emailTemplate);

                this._TemplatesService.postSaveEmailTemplate(emailTemplate).subscribe(data => {
                    console.log('response_PostSaveEmailTemplate', data);

                    if (this._Globals.validationToken(data.result.Result)) {
                        if (data.result.Result == 1) {
                            this.toastr.success('Email template saved successfully', 'ELI');
                            // savingTemplate stays true: the page navigates away
                            if(Number(this.type) === AssessmentTypeEnum.Standard){
                                this._router.navigate(['/app/cemails/custom/standard']);
                            } else {
                                this._router.navigate(['/app/cemails/custom/360']);
                            }
                            return;
                        }

                        this.toastr.error('We are sorry. An error happened while trying to save the email template.', 'ELI');
                    }
                    this.savingTemplate = false;
                },
                (error) => {
                    this.toastr.error('We are sorry. An error happened while trying to save the email template.', 'ELI');
                    this.savingTemplate = false;
                });
            },
            (error) => {
                this.toastr.error('We are sorry. An error happened while trying to check the email template name.', 'ELI');
                this.savingTemplate = false;
            });
    }

    // Body text without html tags
    getBodyText(html: string): string {
        return (html || '')
            .replace(/<[^>]*>/g, '')      // remove html tags (e.g. <strong>)
            .replace(/&nbsp;/g, ' ');
    }

    // Empty editor (null), only spaces or only empty tags. An image counts as content.
    isBodyEmpty(html: string): boolean {
        if (html == null) return true;
        if (/<img/i.test(html)) return false;
        return this.getBodyText(html).trim() === '';
    }

    // Required fields only apply to 360 + Rater + Invitation/Reminder templates
    requiredFieldsApply(type: string, purpose: string, userType: string): boolean {
        return Number(type) === AssessmentTypeEnum.Threesixty &&
            Number(userType) === UserTypeEnum.Rater &&
            [TemplatePurposeEnum.Invitation, TemplatePurposeEnum.Reminder].includes(Number(purpose));
    }

    // Fields returned by GetTemplateFields with Required = true
    getRequiredFields(): string[] {
        const names: string[] = [];
        this.templateFields.forEach(category => {
            (category.Fields || []).forEach(field => {
                if (field.Required && !names.includes(field.Name)) names.push(field.Name);
            });
        });
        return names;
    }

    // Returns the missing required fields per localization.
    // English is always checked; other languages only when their body has content.
    // The language name is only shown when more than one language is checked.
    getMissingRequiredFields(): string[] {
        const requiredFields = this.getRequiredFields();
        const localizationsToCheck = this.localizations.filter(l => l.Language == 'en' || !this.isBodyEmpty(l.Body));
        const showLanguage = localizationsToCheck.length > 1;
        const missing: string[] = [];

        localizationsToCheck.forEach(localization => {
            // Search the raw html: the field must be complete (not split by tags like {Rater <em>Code</em>})
            // so the backend can replace it when sending the email
            const body = localization.Body || '';
            const missingInBody = requiredFields.filter(field => !body.includes(`{${field}}`));

            if (missingInBody.length > 0) {
                const fields = missingInBody.map(f => `{${f}}`).join(', ');

                if (!showLanguage) {
                    missing.push(fields);
                    return;
                }

                const language = this.languages.find(l => l.ShortCode == localization.Language);
                const languageName = language ? language.Name : localization.Language;
                missing.push(`${languageName}: ${fields}`);
            }
        });

        return missing;
    }

    preventSpace(value: string, event: any) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $('#subject').val('');
        }
    }

    deleteEmailTemplate() {
        this._AdminService.postDeleteEmailTemplate(this.templateId).subscribe((data: any) => {
            console.log('response_deleteEmailTemplate', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result === 1) {
                    this.toastr.success('Email Template deleted successfully.', 'ELI');
                    if(Number(this.type) === AssessmentTypeEnum.Standard){
                        this._router.navigate(['/app/cemails/custom/standard']);
                    } else {
                        this._router.navigate(['/app/cemails/custom/360']);
                    }
                } else if (data.result.Result < 0) {
                    this.toastr.warning('This template cannot be deleted because it is being used either in an assessment or assignment.', 'ELI');
                    this.closeModalConfirmation();
                }
            } 
        });
    }

    openPreviewEmailModal() {
        const subject = $('#subject').val();
        
        this._TemplatesService.postPreviewEmailTemplateSendingTemplate(subject, this.editorContent)
            .subscribe((response: any) => {
                if (this._Globals.validationToken(response.result.Result)) {
                    if (response.result.Result == 1) {

                        const template = JSON.parse(response.result.Data);

                        const returnBody = template.Body;

                        $("#coachEmailPreviewModal").modal({ backdrop: "static" });
                        $('#coachEmailPreviewModal').modal('show');
                        $('#prevSubject').val(subject);
                        $('#body').html(returnBody);

                        return;
                    }
    
                    this.toastr.error('We are sorry. An error happened while trying get email preview.', 'ELI');
                }
            },
            (error) => {
                this.toastr.error('Unexpected error trying to get email preview.', 'ELI');
            });
    }

    public openSendPreviewEmailModal(): void {
        $('#sendPreviewEmailModal').modal({ backdrop: 'static' });
        $('#sendPreviewEmailModal').modal('show');
    }
    
    public sendPreviewEmail(): void {
        // if (this.recipientInputControl.invalid) {
        //     this.recipientInputControl.markAsDirty();

        //     $('#emailAddressInput').css('-webkit-box-shadow', '0px 0px 20px 6px rgba(255,57,65,0.73)'); 
        //     $('#emailAddressInput').css('box-shadow', '0px 0px 20px 6px rgba(255,57,65,0.73)');

        //     setTimeout(() => {
        //         $('#emailAddressInput').css('-webkit-box-shadow', 'none'); 
        //         $('#emailAddressInput').css('box-shadow', 'none');
        //     }, 1500);

        //     return;
        // }

        if (this.sendingPreview) {
            return;
        }

        this.sendingPreview = true;

        const recipient = this._Globals.getUserEmail();
        
        const subject = String($('#subject').val()) + ' (preview)';
        
        this._TemplatesService.postPreviewEmailTemplateSendingTemplate(subject, this.editorContent)
            .subscribe((response: any) => {
                if (this._Globals.validationToken(response.result.Result)) {
                    if (response.result.Result == 1) {

                        const template = JSON.parse(response.result.Data);

                        const returnBody = template.Body;

                    this._AdminService.postSendEmail([recipient], subject, returnBody, [])
                        .subscribe((response: any) => {
                            if (this._Globals.validationToken(response.result.Result)) {
                                if (response.result.Result === 1) {
                                    this.toastr.success('A copy of this preview message has been sent to your registered email address.', 'ELI');
                                    $('#emailAddressInput').val('');
                                    $('#sendPreviewEmailModal').modal('hide');
                                    this.sendingPreview = false;

                                    return;
                                }
                            }
                            this.toastr.error('We are sorry. An error happened while trying send email preview.', 'ELI');

                            $('#emailAddressInput').val('');
                            $('#sendPreviewEmailModal').modal('hide');
                            this.sendingPreview = false;
                        },
                        (err) => {
                            this.sendingPreview = false;
                        });

                        return;
                    }
                    
                } else {
                    this.toastr.error('We are sorry. An error happened while trying get email preview.', 'ELI');
                    this.sendingPreview = false;
                } 
            },
            (error) => {
                this.toastr.error('Unexpected error trying to get email preview.', 'ELI');
                this.sendingPreview = false;
            });  
    }

    /*Confirmation Delete*/
    openConfirmationModal() {
        $('#confirmationDeleteModal').modal({ backdrop: 'static' });
        $('#confirmationDeleteModal').modal('show');

    }

    closeModalConfirmation() {
        $('#confirmationDeleteModal').modal('hide');
    }

    closePreviewModal(): void {
        $('#coachEmailPreviewModal').modal('hide');
    }

}
